import Card, { CardProps } from './Card'
import Loader from './Loader'

interface CardWithBorderProps extends CardProps {
  childrenHeight?: string
}

function CardWithBorder({ className, title, children, visible = false, childrenHeight }: CardWithBorderProps) {
  return (
    <Card className={`${className} relative border-t-[3px] border-[#00CC00]`} title={title}>
      <Loader visible={visible} />
      {visible ? <div className={`w-full min-h-[33vh] ${childrenHeight}`} /> : children}
    </Card>
  )
}

CardWithBorder.defaultProps = {
  childrenHeight: '',
}

export default CardWithBorder
